import React from "react";
import "primereact/resources/themes/nova/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./Interceptors";
import { ProgressBar } from "primereact/progressbar";
import { useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import { decryptBase64AES, decryptBase64GCM, setLocaleFalcon } from "./utils/utils";
import { useTheme } from "./contexts/ThemeContext";
import { addLocale } from "primereact/api";

// Configurar locale português brasileiro globalmente
addLocale('pt-BR', {
        firstDayOfWeek: 1,
        showMonthAfterYear: true,
        dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
        dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
        dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
        monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
        monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
        today: 'Hoje',
        clear: 'Limpar'
});

export default function App({ children }) {
    const location = useLocation();
    const { theme } = useTheme();
    
    // Páginas que não devem usar o layout (Login, etc)
    const noLayoutRoutes = ['/entrar', '/agendamento', '/recuperar-senha', '/resetar-senha'];
    const isNoLayoutRoute = noLayoutRoutes.some(route => location.pathname.includes(route));

    return (
        <div className={theme === "dark" ? "dark-theme" : "light-theme"}>
            <div
                id="App-process-bar"
                style={{
                    display: "none",
                    position: "fixed",
                    width: "100%",
                    height: "100%",
                    zIndex: 999999999,
                }}
            >
                <ProgressBar
                    mode="indeterminate"
                    color="blue"
                    style={{ height: "3px" }}
                ></ProgressBar>
            </div>

            {isNoLayoutRoute ? (
                children
            ) : (
                <Layout>
                    {children}
                </Layout>
            )}
        </div>
    );
}

